<template>
  <div v-if="status" class="fullLoading primary">
    <v-row class="fill-height" justify="center" align="center">
      <v-col cols="12" class="text-center">
        <img :src="$getWhitelabelUI('navLogo').fullPath">
        <p class="white--text subheading">
          <v-progress-circular v-if="progressType === 'circular'"
                               :width="2"
                               :size="15"
                               indeterminate
                               color="white" />

          <v-progress-circular v-else-if="progressType === 'linear'"
                               :width="2"
                               :size="15"
                               indeterminate
                               color="white" />
          <span class="ml-2">
            {{ message || $t('loading_initial_data') }}
          </span>
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RegFullLoading',
  props: {
    when: {
      type: Boolean,
      default: false
    },
    loader: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    message: {
      type: String,
      default: ''
    },
    progressType: {
      type: String,
      default: 'circular'
    }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    isLoading() {
      const store = this.$store
      if (!store) {
        throw new Error('Vuex not initialized.')
      }
      return store.getters.isLoading
    },
    anyLoading() {
      const store = this.$store
      if (!store) {
        throw new Error('Vuex not initialized.')
      }
      return store.getters.anyLoading
    },
    status() {
      if (this.when) {
        return this.when
      }
      if (this.loader) {
        return this.isLoading(this.loader)
      }
      return this.anyLoading
    }
  }
}
</script>

<style lang="scss">
.fullLoading {
  position: absolute;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
